import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { WorkflowApi } from '../../types/generated.types';

@Injectable({ providedIn: 'root' })
export class WorkflowApisApiService extends BaseApiService {
  protected get baseUrl(): string {
    return `${super.baseUrl}/workflow-apis`;
  }

  async getWorkflowApis(): Promise<WorkflowApi[]> {
    return await this.get<WorkflowApi[]>('');
  }

  async getWorkflowApi(id: string): Promise<WorkflowApi> {
    return await this.get<WorkflowApi>(id);
  }

  async createWorkflowApi(workflowApi: WorkflowApi): Promise<string> {
    return await this.postWithResult<WorkflowApi, string>('', workflowApi);
  }

  async updateWorkflowApi(workflowApi: WorkflowApi): Promise<void> {
    return await this.put<WorkflowApi>('', workflowApi);
  }

  async deleteWorkflowApi(id: string): Promise<void> {
    return await this.delete(id);
  }
}